import { Clock, Brain, FileCheck, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ScrollReveal } from './ScrollReveal';

const benefitIcons = [Clock, Brain, FileCheck, TrendingUp];

export function Benefits() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: benefitIcons[0],
      titleKey: 'benefits.time.title',
      descriptionKey: 'benefits.time.description',
    },
    {
      icon: benefitIcons[1],
      titleKey: 'benefits.therapy.title',
      descriptionKey: 'benefits.therapy.description',
    },
    {
      icon: benefitIcons[2],
      titleKey: 'benefits.documentation.title',
      descriptionKey: 'benefits.documentation.description',
    },
    {
      icon: benefitIcons[3],
      titleKey: 'benefits.growth.title',
      descriptionKey: 'benefits.growth.description',
    },
  ];

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <ScrollReveal>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              {t('benefits.title')}
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={1}>
            <p className="text-lg text-gray-600">
              {t('benefits.subtitle')}
            </p>
          </ScrollReveal>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <ScrollReveal key={index} delay={(index % 6) + 1}>
              <div className="flex gap-6 p-6 rounded-xl bg-gray-50 hover:bg-teal-50 transition-colors">
                <div className="flex-shrink-0">
                  <div className="bg-teal-100 rounded-lg p-4">
                    <benefit.icon className="size-8 text-teal-600" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {t(benefit.titleKey)}
                  </h3>
                  <p className="text-gray-600">
                    {t(benefit.descriptionKey)}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
